import { Inbox } from 'lucide-react'

export function EmptyState({ title = '暂无数据', detail = '当前筛选条件下没有记录' }) {
  return <div className="empty-state"><Inbox size={28} /><strong>{title}</strong><span>{detail}</span></div>
}

